import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Badge } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { ArrowBack } from '@mui/icons-material';
import cart from '../../static/images/cart.png';
import del from '../../static/images/del.png';
import { withTranslation } from 'react-i18next';

const styles = () => ({
  customBadge: {
    top: '25px !important',
  },
});

@inject('commonStore', 'cartStore', 'orderStore')
@observer
class Header extends Component {
  handleClickBack = () => {
    const { history, location, isGoHome, commonStore } = this.props;
    const referrer = document.referrer;
    const referrerDomain = referrer ? new URL(referrer).hostname : '';
    const currentDomain = window.location.hostname;

    // 리퍼러가 UP스마트오더 사이트가 아닌 경우 (PG사이트 이동 등) 홈페이지로 이동
    if (referrerDomain !== currentDomain && commonStore.companyId && commonStore.storeCode) {
      window.location.href = `/${commonStore.companyId}/${commonStore.storeCode}${location.search}`;
    } else if (isGoHome) {
      window.location.href = `/${commonStore.companyId}/${commonStore.storeCode}${location.search}`;
    } else {
      history.goBack();
    }
  };

  handleClickCart = () => {
    const { commonStore, history, location } = this.props;
    history.push(`/${commonStore.companyId}/${commonStore.storeCode}/cart${location.search}`);
  };

  handleClickCartClear = () => {
    const { t, commonStore, cartStore } = this.props;
    commonStore.openConfirmDialog(t('cart.confirm.removeAll'), () => {
      cartStore.clearCart();
    });
    //this.props.cartStore.setDialogOpen(true);
  };

  // 뒤로가기 버튼
  renderBackButton = () => {
    if (this.props.disabledBackButton) return undefined;
    if (this.props.orderStore?.order?.extOrderNo) return undefined;
    return (
      <IconButton edge="start" color="inherit" onClick={this.handleClickBack} size="large">
        <ArrowBack />
      </IconButton>
    );
  };

  // 우측 상단 아이콘
  renderIcon = () => {
    const { iconType, cartStore, orderStore, classes } = this.props;
    if (orderStore?.order?.extOrderNo) return undefined;

    switch (iconType) {
      case 'CART_CLEAR':
        return (
          <IconButton edge="end" color="inherit" onClick={this.handleClickCartClear} size="large">
            <img src={del} height="28" alt="장바구니 전체 비우기" />
          </IconButton>
        );
      case 'CART':
        return (
          <IconButton edge="end" color="inherit" onClick={this.handleClickCart} size="large">
            <Badge badgeContent={cartStore.totalCnt} classes={{ badge: classes.customBadge }}>
              <img src={cart} height="28" alt="장바구니" />
            </Badge>
          </IconButton>
        );
      default:
        return undefined;
    }
  };

  render() {
    const { title } = this.props;
    // 마장동 주문일땐 홈 화면 접근 불가
    return (
      <AppBar position="fixed" color="primary" style={{ boxShadow: 'none' }}>
        <Toolbar style={{ minHeight: '60px' }}>
          {/** 뒤로가기 버튼 */}
          {this.renderBackButton()}

          {/** 타이틀 */}
          <div className="title" style={{ flexGrow: 1, textAlign: 'center' }}>
            {title}
          </div>

          {/** 장바구니 페이지인 경우 전체 삭제 버튼 아닌경우 장바구니 아이콘 */}
          {this.renderIcon()}
        </Toolbar>
      </AppBar>
    );
  }
}

export default withRouter(withStyles(styles)(withTranslation()(Header)));
